import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";

const EditUserModel = ({
  editUserMutate,
  editUserLoading,
  setEditUser,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    if (!values.name) {
      toast.error("Please enter your Name");
      return;
    }
    editUserMutate(values);
  };

  const formik = useFormik({
    initialValues: {
      name: selectedData?.name || "",
      mobile: selectedData?.mobile || "",
      status: selectedData?.status || "",
      email: selectedData?.email || "",
      city: selectedData?.city || "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Enter a valid number")
        .required("Mobile number is required"),
      status: Yup.number().required("Select Status"),
      city: Yup.string().required("City is required"),
      email: Yup.string()
        .matches(
          /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
          "Enter a valid email address",
        )
        .nullable()
        .notRequired()
        .transform((value) => (value === "" ? null : value)),
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditUser}>
      {editUserLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit User</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="name">Name</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="name"
                      id="name"
                      autoComplete="off"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.name}
                      </p>
                    )}
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="mobile">Phone</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="mobile"
                      id="mobile"
                      // className="bg-gray-100"
                      autoComplete="off"
                      value={formik.values.mobile}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.mobile && formik.errors.mobile ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.mobile}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="email">Email</Label>
                  <FieldWrapper>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      autoComplete="off"
                      // className="truncate"
                      onChange={formik.handleChange}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.email}
                      </p>
                    )}
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="status">Status</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="status"
                      id="status"
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      <MenuItem value="1">Pending</MenuItem>
                      <MenuItem value="2">Active</MenuItem>
                      <MenuItem value="3">Inactive</MenuItem>
                      <MenuItem value="4">Suspended</MenuItem>
                    </Select>
                    {formik.touched.status && formik.errors.status && (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.status}
                      </p>
                    )}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <InputGroup>
                <Label htmlFor="city">City</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="city"
                    id="city"
                    // className="bg-gray-100"
                    autoComplete="off"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.city && formik.errors.city ? (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.city}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditUserModel;
